import React from 'react';
import ChevronLeftIcon from "@heroicons/react/20/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/20/solid/ChevronRightIcon";


function Pagination({ currentPage, lastPage, showDataByLink, id }) {
  const maxPagesToShow = 2;
  const pagesArray = [];


  for (let i = 1; i <= lastPage; i++) {
    pagesArray.push(i);
  }

  const renderPageButtons = () => {
    if (lastPage <= maxPagesToShow) {
      // If the total number of pages is less than or equal to maxPagesToShow, show all pages.
      return pagesArray.map((page) => (
        <button
          key={page}
          onClick={() => showDataByLink(page)}
          className={`${
            page === currentPage ? 'bg-gray-800 text-white' : 'text-base leading-none text-gray-800'
          } border-b-2 border-transparent focus:outline-none focus:border-gray-800 px-2`}
        >
          <p>{page}</p>
        </button>
      ));
    } else {
      // If the total number of pages is greater than maxPagesToShow, show a subset of pages around the current page.
      const halfMax = Math.floor(maxPagesToShow / 2);
      const startPage = Math.max(1, currentPage - halfMax);
      const endPage = Math.min(lastPage, currentPage + halfMax);

      let pageButtons = [];

      if (startPage > 1) {
        pageButtons.push(
          <button key={1} onClick={() => showDataByLink(1)} className="text-base leading-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800 px-2">
            <p>1</p>
          </button>
        );
        if (startPage > 2) {
          pageButtons.push(
            <span key="startEllipsis" className="text-base leading-none text-gray-800 px-2">
              ...
            </span>
          );
        }
      }

      for (let page = startPage; page <= endPage; page++) {
        pageButtons.push(
          <button
            key={page}
            onClick={() => showDataByLink(page)}
            className={`${
              page === currentPage ? 'bg-gray-800 text-white' : 'text-base leading-none text-gray-800'
            } border-b-2 border-transparent focus:outline-none focus:border-gray-800 px-2`}
          >
            <p>{page}</p>
          </button>
        );
      }

      if (endPage < lastPage) {
        if (endPage < lastPage - 1) {
          pageButtons.push(
            <span key="endEllipsis" className="text-base leading-none text-gray-800 px-2">
              ...
            </span>
          );
        }
        pageButtons.push(
          <button
            key={lastPage}
            onClick={() => showDataByLink(lastPage)}
            className={`${
              lastPage === currentPage ? 'bg-gray-800 text-white' : 'text-base leading-none text-gray-800'
            } border-b-2 border-transparent focus:outline-none focus:border-gray-800 px-2`}
          >
            <p>{lastPage}</p>
          </button>
        );
      }

      return pageButtons;
    }
  };

  return (
   /* <div className="flex justify-end items-end mt-12 ">
      <div className="flex flex-row items-center justify-center space-x-4">
        {currentPage > 1 && (
          <button
            onClick={() => showDataByLink(currentPage - 1)}
            className="text-base leading-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800 flex items-center"
          >
            <ChevronLeftIcon className="w-4 h-4 mr-1" /> Prev
          </button>
        )}

        {renderPageButtons()}

        {currentPage < lastPage && (
          <button
            onClick={() => showDataByLink(currentPage + 1)}
            className="text-base leading-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800 flex items-center"
          >
            Next <ChevronRightIcon className="w-4 h-4 ml-1" />
          </button>
        )}
      </div>
    </div>*/




   /*<div className="mt-12  flex justify-center items-center space-x-4">
      {currentPage > 1 && (

          <button
        onClick={() => showDataByLink(currentPage - 1)}
        className="text-base leading-none text-gray-800 border-b-2 px-2 py-1  hover:bg-gray-100 focus:outline-none border-transparent focus:outline-none focus:border-gray-800 flex items-center"
      >
        <h1 style={{margin:0, padding:0}} className={'home__description'}><ChevronLeftIcon   className="w-4 h-4 mr-1 " /></h1> <h1 style={{margin:0, padding:0}} className={'home__description'}>Previous</h1>
      </button>

        /!*<button
          onClick={() => showDataByLink(currentPage - 1)}
          className="px-2 py-1 border rounded-md border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          <ChevronLeftIcon className="w-4 h-4 mr-1" /> Previous
        </button>*!/
      )}

      <button
        onClick={() => showDataByLink(1)}
        className={`${
          1 === currentPage
            ? 'bg-gray-800 text-white'
            : 'text-base leading-none text-gray-800 hover:bg-gray-100 focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300'
        }`}
      >
        <h1 style={{margin:0, padding:0}} className={'home__description'}> 1</h1>
      </button>

      {currentPage > 2 && <span className="text-base leading-none text-gray-800"><h1 style={{margin:0, padding:0}} className={'home__description'}></h1></span>}

      {currentPage !== 1 && currentPage !== lastPage && (
        <button
          onClick={() => showDataByLink(lastPage)}
          className={`${
            lastPage === currentPage
              ? 'bg-gray-800 text-white'
              : 'text-base leading-none text-gray-800 hover:bg-gray-100 focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300'
          }`}
        >

            <h1 style={{margin:0, padding:0}} className={'home__description'}> {lastPage}</h1>
        </button>
      )}

      {currentPage < lastPage && (
        <button
        onClick={() => showDataByLink(currentPage + 1)}
        className="text-base leading-none  border-b-2 px-2 py-1  hover:bg-gray-100 focus:outline-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800 flex items-center"
      >



          <h1 style={{margin:0, padding:0}} className={'home__description'}>Next</h1> <h1 style={{margin:0, padding:0}} className={'home__description'}><ChevronRightIcon   className="w-4 h-4 mr-1 " /></h1>
      </button>
      )}
    </div>*/



         <div className="mt-12 flex justify-center items-center space-x-4">
      {currentPage > 1 && (
           <a href={`#${id}`}  onDragStart={(event) => event.preventDefault()}>
             <button
                  onDragStart={(event) => event.preventDefault()}
        onClick={() => showDataByLink(currentPage - 1)}
        className="text-base leading-none text-gray-800 border-b-2 px-2 py-1  hover:text-blue-500 focus:outline-none border-transparent focus:outline-none focus:border-gray-800 flex items-center"
      >
        <h1 style={{margin:0, padding:0, fontWeight:"bold"}} className={'home__description hover:text-blue-500'}><ChevronLeftIcon   className="w-4 h-4 mr-1 " /></h1> <h1 style={{margin:0, padding:0, fontWeight:"bold"}} className={'home__description hover:text-blue-500'}>Prev</h1>
      </button>
           </a>
      )}

       {/*<a href={`#${id}`}  onDragStart={(event) => event.preventDefault()}>
      <button
           style={{margin:0, padding:0, fontWeight:"bold"}}
           onDragStart={(event) => event.preventDefault()}
        onClick={() => showDataByLink(1)}
        className={`${
          1 === currentPage
            ? '   '
            : 'text-base  home__description leading-none  hover:bg-blue-200  hover:text-blue-500 focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300'
        }`}
      >
        1
      </button>
       </a>*/}
       {currentPage !== 1 && (
  <a href={`#${id}`} onDragStart={(event) => event.preventDefault()}>
    <button
      style={{ margin: 0, padding: 0, fontWeight: "bold" }}
      onDragStart={(event) => event.preventDefault()}
      onClick={() => showDataByLink(1)}
      className="text-base home__description leading-none hover:bg-blue-200 hover:text-blue-500 focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300"
    >
      1
    </button>
  </a>
)}


      {currentPage > 2 && <span className="text-base leading-none text-gray-800">...</span>}

      {/*{currentPage !== 1 && currentPage !== lastPage && (
           <a href={'#top'}>
        <button
             style={{margin:0, padding:0, fontWeight:"bold"}}
             onDragStart={(event) => event.preventDefault()}
          onClick={() => showDataByLink(currentPage)}
          className="bg-gray-300 home__description text-base  hover:bg-blue-200 leading-none text-gray-500  focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300"
        >
          {currentPage}
        </button>
           </a>
      )}*/}

      {currentPage !== 1 && currentPage !== lastPage && (
  <a href={`#${id}`}  onDragStart={(event) => event.preventDefault()}>
    <button
      style={{ margin: 0, padding: 0, fontWeight: "bold" }}
      onDragStart={(event) => event.preventDefault()}
      onClick={() => showDataByLink(currentPage)}
       className="bg-gray-300 home__description text-base  hover:bg-blue-200 leading-none text-gray-500  focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300"
      // Conditionally apply bg-gray-300 class when currentPage is not 1 or lastPage
      className={currentPage !== 1 && currentPage !== lastPage ? "bg-gray-300 home__description text-base  hover:bg-blue-200 leading-none text-gray-500  focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300" : ""}
    >
      {currentPage}
    </button>
  </a>
)}


      {currentPage < lastPage - 1 && <span className="text-base leading-none text-gray-800">...</span>}

      {currentPage !== 1 && currentPage !== lastPage && (
           <a href={`#${id}`}  onDragStart={(event) => event.preventDefault()}>
        <button
             onDragStart={(event) => event.preventDefault()}
          onClick={() => showDataByLink(lastPage)}
              style={{margin:0, padding:0, fontWeight:"bold"}}
          className="home__description  text-base leading-none  hover:bg-blue-200 focus:outline-none rounded-full h-8 w-8 flex items-center justify-center border border-gray-300"
        >
          {lastPage}
        </button>
           </a>
      )}

      {currentPage < lastPage && (
         <a href={`#${id}`}  onDragStart={(event) => event.preventDefault()}>
           <button

        onClick={() => showDataByLink(currentPage + 1)}
        className="text-base hover:text-blue-500 leading-none  border-b-2 px-2 py-1   focus:outline-none text-gray-800 border-b-2 border-transparent focus:outline-none focus:border-gray-800 flex items-center"
      >

          <h1 style={{margin:0, padding:0, fontWeight:"bold"}} className={'home__description text-bold hover:text-blue-500'}>Next</h1> <h1 style={{margin:0, padding:0, fontWeight:"bold"}} className={'home__description hover:text-blue-500'}><ChevronRightIcon   className="w-4 h-4 mr-1 " /></h1>
      </button>
         </a>
      )}
    </div>
  );
}

export default Pagination;
